/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactNode } from "react";
import { URLS } from "../../../infra/URLS";
import { IconSeparadorCaminho } from "../../Icons/IconSeparadorMenu";
import { IconTouro } from "../../Icons/IconTouro";
import { Caminho } from "../Caminho";
import { Sidebar } from "../MenuSidebar/Sidebar";
import { Navbar } from "../Navbar";
import { TituloPagina } from "../Titulos";

interface PageHeaderProps {
  titulo: string,
  icon?: ReactNode,
  componente?: ReactNode,
}

export function PageHeader({ titulo, icon, componente } : PageHeaderProps){
  return (
    <>
      <div className="flex pt-32 pb-16 container flex-row items-center h-[20vh] justify-between mx-auto">
        <div>
          <Caminho 
            children={
              <>
                <a href={URLS.DASHBOARD}>Início</a>
                <IconSeparadorCaminho />
                {titulo}
              </>
            }        
          />
        <TituloPagina 
          icon={icon}
          titulo={titulo}
          />
        </div>
        <div>
          {componente}
        </div>
      </div>
    </>
  );
}